import React from 'react'

const CustomBackgroundLeftArrow = (props) => {
  return (
    <button
      onClick={() => props.onClick?.()}
      className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left custom-arrow left background"
      aria-label="Left Arrow"
    ></button>
  )
}
export default CustomBackgroundLeftArrow